// import React, { useState, useEffect } from "react";
// import { Container, Table, Spinner, Alert, Button } from "react-bootstrap";
// import usePatientDetails from "../../hooks/usePatientDetails";

// const PatientVitalsPage = () => {
//   const [vitals, setVitals] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [patientId, setPatientId] = useState(null);

//   // Conditionally call hook only if patientId is truthy
//   const {
//     info: patient,
//     loading: patientInfoLoading,
//     error: patientInfoError,
//   } = usePatientDetails(patientId);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const id = urlParams.get("patientId");

//     if (id) {
//       setPatientId(id);
//       fetchVitals(id);
//     } else {
//       setError("No patient ID provided");
//       setLoading(false);
//     }
//   }, []);

//   const fetchVitals = async (id) => {
//     try {
//       setLoading(true);
//       setError("");

//       const endpoints = [
//         { key: "temperature", url: `/vitals/patient/${id}/temperature/latest` },
//         { key: "heart_rate", url: `/vitals/patient/${id}/heart_rate/latest` },
//         { key: "spo2", url: `/vitals/patient/${id}/spo2/latest` },
//         { key: "battery_level", url: `/vitals/patient/${id}/battery/latest` },
//         { key: "steps_count", url: `/vitals/patient/${id}/steps/latest` },
//       ];

//       const results = await Promise.all(
//         endpoints.map((e) =>
//           fetch(`http://localhost:8000${e.url}`).then((res) =>
//             res.ok ? res.json() : null
//           )
//         )
//       );

//       console.log("Fetched vitals results:", results);

//       const vitalsData = {};
//       endpoints.forEach((e, i) => {
//         const data = results[i];
//         if (data) {
//           vitalsData[e.key] = data[e.key] ?? null;
//           vitalsData[`${e.key}_time`] = data.time ?? null;
//         } else {
//           vitalsData[e.key] = null;
//           vitalsData[`${e.key}_time`] = null;
//         }
//       });

//       console.log("Processed vitalsData:", vitalsData);

//       setVitals(vitalsData);
//     } catch (err) {
//       setError("Network or server error.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadReport = async () => {
//     const jsPDF = (await import("jspdf")).default;
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text("Patient Vitals Report", 105, 15, null, null, "center");

//     if (patient) {
//       doc.setFontSize(12);
//       doc.text(`Name: ${patient.patient_name}`, 10, 30);
//       doc.text(`Patient ID: ${patient.patient_id}`, 10, 40);
//       doc.text(`Gender: ${patient.gender}`, 10, 50);
//       doc.text(`Age: ${patient.age}`, 10, 60);
//     }

//     let y = 80;
//     doc.setFont(undefined, "bold");
//     doc.text("Vital", 10, y);
//     doc.text("Value", 80, y);
//     doc.text("Timestamp", 140, y);
//     doc.setFont(undefined, "normal");

//     const addRow = (label, value, time) => {
//       y += 10;
//       doc.text(label, 10, y);
//       doc.text(value ? String(value) : "-", 80, y);
//       doc.text(time ? new Date(time).toLocaleString() : "-", 140, y);
//     };

//     addRow("Temperature (°C)", vitals?.temperature, vitals?.temperature_time);
//     addRow("Heart Rate (bpm)", vitals?.heart_rate, vitals?.heart_rate_time);
//     addRow("SpO₂ (%)", vitals?.spo2, vitals?.spo2_time);
//     addRow("Battery (%)", vitals?.battery_level, vitals?.battery_time);
//     addRow("Steps", vitals?.steps_count, vitals?.steps_time);

//     doc.save(`Vitals_Report_${patient?.patient_id || "Unknown"}.pdf`);
//   };

//   const pageStyle = {
//     padding: "20px",
//     backgroundColor: "#f8f9fa",
//     minHeight: "100vh",
//     fontFamily: "Arial, sans-serif",
//   };

//   const tableStyle = {
//     backgroundColor: "white",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//     borderRadius: "8px",
//   };

//   return (
//     <div style={pageStyle}>
//       <Container fluid>
//         {/* Patient Info Banner */}
//         <div className="container mt-4">
//           {patientInfoLoading ? (
//             <div className="alert alert-info">Loading patient info...</div>
//           ) : patientInfoError ? (
//             <div className="alert alert-danger">{patientInfoError}</div>
//           ) : patient ? (
//             <div className="patient-banner d-flex flex-wrap gap-3 mb-4 p-3 justify-content-between text-dark">
//               <div>
//                 <strong>Patient Name:</strong> {patient.patient_name}
//               </div>
//               <div>
//                 <strong>Patient ID:</strong> {patient.patient_id}
//               </div>
//               <div>
//                 <strong>Gender:</strong> {patient.gender}
//               </div>
//               <div>
//                 <strong>Age:</strong> {patient.age}
//               </div>
//             </div>
//           ) : (
//             <div className="alert alert-warning">No patient assigned</div>
//           )}
//         </div>

//         {/* Report Download Button */}
//         <div style={{ textAlign: "center", marginBottom: "20px" }}>
//           <Button
//             variant="primary"
//             onClick={handleDownloadReport}
//             disabled={!vitals || !patient}
//           >
//             Download Report
//           </Button>
//         </div>

//         {/* Loading Spinner */}
//         {loading && (
//           <div className="text-center">
//             <Spinner animation="border" variant="primary" />
//             <p>Loading patient vitals...</p>
//           </div>
//         )}

//         {/* Error Message */}
//         {error && (
//           <Alert variant="danger" className="text-center">
//             {error}
//           </Alert>
//         )}

//         {/* Vitals Table */}
//         {vitals && !loading && !error && (
//           <div>
//             <h4 className="mb-3 text-center">Latest Vitals</h4>
//             <Table striped bordered hover responsive style={tableStyle}>
//               <thead style={{ backgroundColor: "#2c3e50", color: "white" }}>
//                 <tr>
//                   <th>Vital</th>
//                   <th>Value</th>
//                   <th>Timestamp</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Temperature (°C)</td>
//                   <td style={{ color: vitals.temperature > 37.5 ? "red" : "green" }}>
//                     {vitals.temperature ?? "-"}
//                   </td>
//                   <td>
//                     {vitals.temperature_time
//                       ? new Date(vitals.temperature_time).toLocaleString()
//                       : "-"}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>Heart Rate (bpm)</td>
//                   <td style={{ color: vitals.heart_rate > 100 ? "red" : "green" }}>
//                     {vitals.heart_rate ?? "-"}
//                   </td>
//                   <td>
//                     {vitals.heart_rate_time
//                       ? new Date(vitals.heart_rate_time).toLocaleString()
//                       : "-"}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>SpO₂ (%)</td>
//                   <td style={{ color: vitals.spo2 < 95 ? "red" : "green" }}>
//                     {vitals.spo2 ?? "-"}
//                   </td>
//                   <td>
//                     {vitals.spo2_time
//                       ? new Date(vitals.spo2_time).toLocaleString()
//                       : "-"}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>Battery (%)</td>
//                   <td>{vitals.battery_level ?? "-"}</td>
//                   <td>
//                     {vitals.battery_level_time
//                       ? new Date(vitals.battery_level_time).toLocaleString()
//                       : "-"}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>Steps</td>
//                   <td>{vitals.steps_count ?? "-"}</td>
//                   <td>
//                     {vitals.steps_count_time
//                       ? new Date(vitals.steps_count_time).toLocaleString()
//                       : "-"}
//                   </td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default PatientVitalsPage;

// import React, { useEffect } from "react";
// import { Container, Table, Spinner, Alert, Button } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";

// import { fetchPatientDetails, selectPatientDetails } from "../../redux/slices/PatientSlice";
// import { fetchLatestTemperature, selectTemperature } from "../../redux/slices/temperatureSlice";
// import { fetchLatestHeartRate, selectHeartRate } from "../../redux/slices/heartRateSlice";
// import { fetchLatestSpO2, selectSpO2 } from "../../redux/slices/spo2Slice";
// import { fetchLatestBattery, selectBattery } from "../../redux/slices/batterySlice";
// import { fetchLatestSteps, selectSteps } from "../../redux/slices/stepsSlice";

// const PatientVitalsPage = () => {
//   const dispatch = useDispatch();

//   // Parse patientId from URL once on mount
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const id = urlParams.get("patientId");
//     if (id) {
//       dispatch(fetchPatientDetails(id));
//       dispatch(fetchLatestTemperature(id));
//       dispatch(fetchLatestHeartRate(id));
//       dispatch(fetchLatestSpO2(id));
//       dispatch(fetchLatestBattery(id));
//       dispatch(fetchLatestSteps(id));
//     } else {
//       // Optionally handle missing patientId with Redux or local state
//     }
//   }, [dispatch]);

//   // Select patient details and vitals from Redux store
//   const { info: patient, loading: patientLoading, error: patientError } = useSelector(selectPatientDetails);

//   const temperatureState = useSelector(selectTemperature);
//   const heartRateState = useSelector(selectHeartRate);
//   const spo2State = useSelector(selectSpO2);
//   const batteryState = useSelector(selectBattery);
//   const stepsState = useSelector(selectSteps);

//   const loading =
//     patientLoading ||
//     temperatureState.loading ||
//     heartRateState.loading ||
//     spo2State.loading ||
//     batteryState.loading ||
//     stepsState.loading;

//   const error =
//     patientError ||
//     temperatureState.error ||
//     heartRateState.error ||
//     spo2State.error ||
//     batteryState.error ||
//     stepsState.error;

//   // Prepare vitals data object for easier rendering
//   const vitals = {
//     temperature: temperatureState.data?.temperature ?? null,
//     temperature_time: temperatureState.data?.time ?? null,
//     heart_rate: heartRateState.data?.heart_rate ?? null,
//     heart_rate_time: heartRateState.data?.time ?? null,
//     spo2: spo2State.data?.spo2 ?? null,
//     spo2_time: spo2State.data?.time ?? null,
//     battery_level: batteryState.data?.battery_level ?? null,
//     battery_level_time: batteryState.data?.time ?? null,
//     steps_count: stepsState.data?.steps_count ?? null,
//     steps_count_time: stepsState.data?.time ?? null,
//   };

//   // Download report function similar as before
//   const handleDownloadReport = async () => {
//     const jsPDF = (await import("jspdf")).default;
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text("Patient Vitals Report", 105, 15, null, null, "center");

//     if (patient) {
//       doc.setFontSize(12);
//       doc.text(`Name: ${patient.patient_name}`, 10, 30);
//       doc.text(`Patient ID: ${patient.patient_id}`, 10, 40);
//       doc.text(`Gender: ${patient.gender}`, 10, 50);
//       doc.text(`Age: ${patient.age}`, 10, 60);
//     }

//     let y = 80;
//     doc.setFont(undefined, "bold");
//     doc.text("Vital", 10, y);
//     doc.text("Value", 80, y);
//     doc.text("Timestamp", 140, y);
//     doc.setFont(undefined, "normal");

//     const addRow = (label, value, time) => {
//       y += 10;
//       doc.text(label, 10, y);
//       doc.text(value ? String(value) : "-", 80, y);
//       doc.text(time ? new Date(time).toLocaleString() : "-", 140, y);
//     };

//     addRow("Temperature (°C)", vitals.temperature, vitals.temperature_time);
//     addRow("Heart Rate (bpm)", vitals.heart_rate, vitals.heart_rate_time);
//     addRow("SpO₂ (%)", vitals.spo2, vitals.spo2_time);
//     addRow("Battery (%)", vitals.battery_level, vitals.battery_level_time);
//     addRow("Steps", vitals.steps_count, vitals.steps_count_time);

//     doc.save(`Vitals_Report_${patient?.patient_id || "Unknown"}.pdf`);
//   };

//   // Styles omitted for brevity (reuse your existing styling)

//   return (
//     <div style={{ padding: 20, backgroundColor: "#f8f9fa", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
//       <Container fluid>
//         {/* Patient Info Banner */}
//         <div className="container mt-4">
//           {patientLoading ? (
//             <Alert variant="info">Loading patient info...</Alert>
//           ) : patientError ? (
//             <Alert variant="danger">{patientError}</Alert>
//           ) : patient ? (
//             <div className="patient-banner d-flex flex-wrap gap-3 mb-4 p-3 justify-content-between text-dark">
//               <div><strong>Patient Name:</strong> {patient.patient_name}</div>
//               <div><strong>Patient ID:</strong> {patient.patient_id}</div>
//               <div><strong>Gender:</strong> {patient.gender}</div>
//               <div><strong>Age:</strong> {patient.age}</div>
//             </div>
//           ) : (
//             <Alert variant="warning">No patient assigned</Alert>
//           )}
//         </div>

//         {/* Report Download Button */}
//         <div style={{ textAlign: "center", marginBottom: 20 }}>
//           <Button variant="primary" onClick={handleDownloadReport} disabled={loading || !patient}>
//             Download Report
//           </Button>
//         </div>

//         {/* Loading Spinner */}
//         {loading && (
//           <div className="text-center">
//             <Spinner animation="border" variant="primary" />
//             <p>Loading patient vitals...</p>
//           </div>
//         )}

//         {/* Error Message */}
//         {error && (
//           <Alert variant="danger" className="text-center">
//             {error}
//           </Alert>
//         )}

//         {/* Vitals Table */}
//         {!loading && !error && vitals && (
//           <>
//             <h4 className="mb-3 text-center">Latest Vitals</h4>
//             <Table striped bordered hover responsive style={{ backgroundColor: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", borderRadius: "8px" }}>
//               <thead style={{ backgroundColor: "#2c3e50", color: "white" }}>
//                 <tr>
//                   <th>Vital</th>
//                   <th>Value</th>
//                   <th>Timestamp</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Temperature (°C)</td>
//                   <td style={{ color: vitals.temperature > 37.5 ? "red" : "green" }}>
//                     {vitals.temperature ?? "-"}
//                   </td>
//                   <td>{vitals.temperature_time ? new Date(vitals.temperature_time).toLocaleString() : "-"}</td>
//                 </tr>
//                 <tr>
//                   <td>Heart Rate (bpm)</td>
//                   <td style={{ color: vitals.heart_rate > 100 ? "red" : "green" }}>
//                     {vitals.heart_rate ?? "-"}
//                   </td>
//                   <td>{vitals.heart_rate_time ? new Date(vitals.heart_rate_time).toLocaleString() : "-"}</td>
//                 </tr>
//                 <tr>
//                   <td>SpO₂ (%)</td>
//                   <td style={{ color: vitals.spo2 < 95 ? "red" : "green" }}>
//                     {vitals.spo2 ?? "-"}
//                   </td>
//                   <td>{vitals.spo2_time ? new Date(vitals.spo2_time).toLocaleString() : "-"}</td>
//                 </tr>
//                 <tr>
//                   <td>Battery (%)</td>
//                   <td>{vitals.battery_level ?? "-"}</td>
//                   <td>{vitals.battery_level_time ? new Date(vitals.battery_level_time).toLocaleString() : "-"}</td>
//                 </tr>
//                 <tr>
//                   <td>Steps</td>
//                   <td>{vitals.steps_count ?? "-"}</td>
//                   <td>{vitals.steps_count_time ? new Date(vitals.steps_count_time).toLocaleString() : "-"}</td>
//                 </tr>
//               </tbody>
//             </Table>
//           </>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default PatientVitalsPage;


import React, { useEffect } from "react";
import { Container, Table, Spinner, Alert, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { fetchPatientDetails, selectPatientDetails } from "../../redux/slices/PatientSlice";
import { fetchLatestTemperature, selectTemperature } from "../../redux/slices/temperatureSlice";
import { fetchLatestHeartRate, selectHeartRate } from "../../redux/slices/heartRateSlice";
import { fetchLatestSpO2, selectSpO2 } from "../../redux/slices/spo2Slice";
import { fetchLatestBattery, selectBattery } from "../../redux/slices/batterySlice";
import { fetchLatestSteps, selectSteps } from "../../redux/slices/stepsSlice";
import { fetchLatestBloodPressure, selectBloodPressure } from "../../redux/slices/BloodPressureSlice"; // 🔥 NEW

const PatientVitalsPage = () => {
  const dispatch = useDispatch();

  // Parse patientId from URL once on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("patientId");
    if (id) {
      dispatch(fetchPatientDetails(id));
      dispatch(fetchLatestTemperature(id));
      dispatch(fetchLatestHeartRate(id));
      dispatch(fetchLatestSpO2(id));
      dispatch(fetchLatestBattery(id));
      dispatch(fetchLatestSteps(id));
      dispatch(fetchLatestBloodPressure(id)); // 🔥 NEW
    }
  }, [dispatch]);

  // Select patient details and vitals from Redux store
  const { info: patient, loading: patientLoading, error: patientError } = useSelector(selectPatientDetails);

  const temperatureState = useSelector(selectTemperature);
  const heartRateState = useSelector(selectHeartRate);
  const spo2State = useSelector(selectSpO2);
  const batteryState = useSelector(selectBattery);
  const stepsState = useSelector(selectSteps);
  const bloodPressureState = useSelector(selectBloodPressure); // 🔥 NEW

  const loading =
    patientLoading ||
    temperatureState.loading ||
    heartRateState.loading ||
    spo2State.loading ||
    batteryState.loading ||
    stepsState.loading ||
    bloodPressureState.loading; // 🔥 NEW

  const error =
    patientError ||
    temperatureState.error ||
    heartRateState.error ||
    spo2State.error ||
    batteryState.error ||
    stepsState.error ||
    bloodPressureState.error; // 🔥 NEW

  // Prepare vitals data object for easier rendering
  const vitals = {
    temperature: temperatureState.data?.temperature ?? null,
    temperature_time: temperatureState.data?.time ?? null,
    heart_rate: heartRateState.data?.heart_rate ?? null,
    heart_rate_time: heartRateState.data?.time ?? null,
    spo2: spo2State.data?.spo2 ?? null,
    spo2_time: spo2State.data?.time ?? null,
    battery_level: batteryState.data?.battery_level ?? null,
    battery_level_time: batteryState.data?.time ?? null,
    steps_count: stepsState.data?.steps_count ?? null,
    steps_count_time: stepsState.data?.time ?? null,
    // 🔥 NEW Blood Pressure
    systolic: bloodPressureState.data?.systolic ?? null,
    diastolic: bloodPressureState.data?.diastolic ?? null,
    blood_pressure_time: bloodPressureState.data?.time ?? null,
  };

  // Download report function
  const handleDownloadReport = async () => {
    const jsPDF = (await import("jspdf")).default;
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Patient Vitals Report", 105, 15, null, null, "center");

    if (patient) {
      doc.setFontSize(12);
      doc.text(`Name: ${patient.patient_name}`, 10, 30);
      doc.text(`Patient ID: ${patient.patient_id}`, 10, 40);
      doc.text(`Gender: ${patient.gender}`, 10, 50);
      doc.text(`Age: ${patient.age}`, 10, 60);
    }

    let y = 80;
    doc.setFont(undefined, "bold");
    doc.text("Vital", 10, y);
    doc.text("Value", 80, y);
    doc.text("Timestamp", 140, y);
    doc.setFont(undefined, "normal");

    const addRow = (label, value, time) => {
      y += 10;
      doc.text(label, 10, y);
      doc.text(value ? String(value) : "-", 80, y);
      doc.text(time ? new Date(time).toLocaleString() : "-", 140, y);
    };

    addRow("Temperature (°C)", vitals.temperature, vitals.temperature_time);
    addRow("Heart Rate (bpm)", vitals.heart_rate, vitals.heart_rate_time);
    addRow("Blood Pressure (mmHg)", vitals.systolic ? `${vitals.systolic}/${vitals.diastolic}` : "-", vitals.blood_pressure_time); // 🔥 NEW
    addRow("SpO₂ (%)", vitals.spo2, vitals.spo2_time);
    addRow("Battery (%)", vitals.battery_level, vitals.battery_level_time);
    addRow("Steps", vitals.steps_count, vitals.steps_count_time);

    doc.save(`Vitals_Report_${patient?.patient_id || "Unknown"}.pdf`);
  };

  return (
    <div style={{ padding: 20, backgroundColor: "#f8f9fa", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <Container fluid>
        {/* Patient Info Banner */}
        <div className="container mt-4">
          {patientLoading ? (
            <Alert variant="info">Loading patient info...</Alert>
          ) : patientError ? (
            <Alert variant="danger">{patientError}</Alert>
          ) : patient ? (
            <div className="patient-banner d-flex flex-wrap gap-3 mb-4 p-3 justify-content-between text-dark">
              <div><strong>Patient Name:</strong> {patient.patient_name}</div>
              <div><strong>Patient ID:</strong> {patient.patient_id}</div>
              <div><strong>Gender:</strong> {patient.gender}</div>
              <div><strong>Age:</strong> {patient.age}</div>
            </div>
          ) : (
            <Alert variant="warning">No patient assigned</Alert>
          )}
        </div>

        {/* Report Download Button */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <Button variant="primary" onClick={handleDownloadReport} disabled={loading || !patient}>
            Download Report
          </Button>
        </div>

        {/* Loading Spinner */}
        {loading && (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <p>Loading patient vitals...</p>
          </div>
        )}

        {/* Error Message */}
        {error && (
          <Alert variant="danger" className="text-center">
            {error}
          </Alert>
        )}

        {/* Vitals Table */}
        {!loading && !error && vitals && (
          <>
            <h4 className="mb-3 text-center">Latest Vitals</h4>
            <Table striped bordered hover responsive style={{ backgroundColor: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", borderRadius: "8px" }}>
              <thead style={{ backgroundColor: "#2c3e50", color: "white" }}>
                <tr>
                  <th>Vital</th>
                  <th>Value</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Temperature (°C)</td>
                  <td style={{ color: vitals.temperature > 37.5 ? "red" : "green" }}>
                    {vitals.temperature ?? "-"}
                  </td>
                  <td>{vitals.temperature_time ? new Date(vitals.temperature_time).toLocaleString() : "-"}</td>
                </tr>
                <tr>
                  <td>Heart Rate (bpm)</td>
                  <td style={{ color: vitals.heart_rate > 100 ? "red" : "green" }}>
                    {vitals.heart_rate ?? "-"}
                  </td>
                  <td>{vitals.heart_rate_time ? new Date(vitals.heart_rate_time).toLocaleString() : "-"}</td>
                </tr>
                <tr>
                  <td>Blood Pressure (mmHg)</td>        {/* 🔥 NEW */}
                  <td style={{ color: 
                    (vitals.systolic > 140 || vitals.diastolic > 90) ? "red" : 
                    (vitals.systolic < 90 || vitals.diastolic < 60) ? "orange" : "green"
                  }}>
                    {vitals.systolic && vitals.diastolic ? `${vitals.systolic}/${vitals.diastolic}` : "-"}
                  </td>
                  <td>{vitals.blood_pressure_time ? new Date(vitals.blood_pressure_time).toLocaleString() : "-"}</td>
                </tr>
                <tr>
                  <td>SpO₂ (%)</td>
                  <td style={{ color: vitals.spo2 < 95 ? "red" : "green" }}>
                    {vitals.spo2 ?? "-"}
                  </td>
                  <td>{vitals.spo2_time ? new Date(vitals.spo2_time).toLocaleString() : "-"}</td>
                </tr>
                <tr>
                  <td>Battery (%)</td>
                  <td>{vitals.battery_level ?? "-"}</td>
                  <td>{vitals.battery_level_time ? new Date(vitals.battery_level_time).toLocaleString() : "-"}</td>
                </tr>
                <tr>
                  <td>Steps</td>
                  <td>{vitals.steps_count ?? "-"}</td>
                  <td>{vitals.steps_count_time ? new Date(vitals.steps_count_time).toLocaleString() : "-"}</td>
                </tr>
              </tbody>
            </Table>
          </>
        )}
      </Container>
    </div>
  );
};

export default PatientVitalsPage;